import { RegisteredAzureFile, TargetStorageFile } from '../../models/Entities/AzureFiles/AzureFileUpload';
import { ErrorType } from '../../models/HttpError';

export interface AzureRegisteredFilesEntry {
  isLoading: boolean;
  files: RegisteredAzureFile[];
  error: ErrorType | undefined;
  loadedAt: string | undefined;
}

/** Files found in the storage folders of a target */
export interface AzureStorageFilesEntry {
  isLoading: boolean;
  files: TargetStorageFile[];
  error: ErrorType | undefined;
  loadedAt: string | undefined;
}

/** Sponsor of a protocol (owner of the service receipts folder, contract §10.2) */
export interface AzureProtocolSponsorEntry {
  status: 'loading' | 'loaded' | 'failed';
  /** undefined when the protocol contract has no sponsor (or it failed) */
  sponsorId?: number;
}

export interface AzureFilesState {
  /** Registered files keyed by `${entityType}:${entityId}` */
  byTarget: Record<string, AzureRegisteredFilesEntry>;
  /** Storage files keyed by `${entityType}:${entityId}` */
  storageByTarget: Record<string, AzureStorageFilesEntry>;
  /** Sponsor resolved per protocol id */
  protocolSponsors: Record<number, AzureProtocolSponsorEntry>;
}

export const AzureFilesUnloadedState: AzureFilesState = {
  byTarget: {},
  storageByTarget: {},
  protocolSponsors: {},
};
